import { render, staticRenderFns } from "./PortalFieldTags.vue?vue&type=template&id=7f4b2191&"
import script from "./PortalFieldTags.vue?vue&type=script&lang=js&"
export * from "./PortalFieldTags.vue?vue&type=script&lang=js&"
import style0 from "./PortalFieldTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports